module.exports = __webpack_public_path__ + "img/left_2.ad8c2969.svg";